import { inject } from '@angular/core';
import { type CanActivateFn } from '@angular/router';
import { UserService } from '../state/user.service';

export const userAuthenticatedGuard: CanActivateFn = async (route, state) => {
    const userService = inject(UserService);

    await userService.initializeAuthentication();

    if (userService.isAuthenticated()) {
        return true;
    }

    const destination = route.queryParamMap.get('destination') ?? state.url;

    return userService.getLoginUrl(destination);
};
